export const SIMULATION_LIST_ROUTE_KEY = 'simulation-list';
export const SIMULATION_LIST_STORE_KEY = 'simulation-list-store';
